export const brandName = "潜声投稿";

export const brandTagline = "让真相安全抵达";

export const contactEmail = "tips@qiansheng.online";

export const homeStats = [
  { id: "s1", value: "12,480+", label: "累计接收线索", note: "图文 · 视频 · 录音全类型" },
  { id: "s2", value: "6 小时", label: "平均首次响应", note: "工作日内完成初步核实" },
  { id: "s3", value: "100%", label: "支持全程匿名", note: "手机号与邮箱均为选填" },
  { id: "s4", value: "4 类", label: "独立投稿通道", note: "按素材类型自由选择" },
];

export const channels = [
  {
    id: "article",
    slug: "article",
    icon: "ri-article-line",
    name: "图文投稿通道",
    short: "文字线索与截图材料",
    summary:
      "适合提交文字描述、聊天记录截图、合同照片、票据凭证等静态材料。填写表单即可直达编辑，无需注册账号。",
    scenes: ["事件经过文字描述", "聊天记录与对话截图", "合同、票据、通知文件照片", "公开可查的资料与凭证"],
    requirements: ["截图请保留完整时间与来源标识", "涉及他人姓名、电话请先打码", "单条描述建议控制在 500 字以内", "可附上你希望核实的具体问题"],
    tag: "最常用",
  },
  {
    id: "private",
    slug: "private",
    icon: "ri-chat-private-line",
    name: "匿名私信投稿",
    short: "一对一匿名沟通",
    summary:
      "不想一次性说完，或担心描述不完整？留下一种安全的联系方式，编辑会主动与你匿名对接，边聊边补充细节。",
    scenes: ["情况复杂、需要多次沟通", "暂时不确定材料是否可用", "希望先确认安全再决定是否提交", "需要专业判断的行业内部信息"],
    requirements: ["建议使用临时邮箱或新注册账号", "沟通中同样避免直接暴露真实身份", "不要提供与线索无关的个人信息", "可约定固定的沟通时间段"],
    tag: "适合复杂线索",
  },
  {
    id: "video",
    slug: "video",
    icon: "ri-video-line",
    name: "视频素材上传",
    short: "现场、监控与记录素材",
    summary:
      "支持现场拍摄视频、监控片段、行车记录仪画面等动态材料。提交后编辑会通过安全链接引导你上传原文件。",
    scenes: ["手机现场拍摄的突发事件", "门店、工地、车间监控片段", "行车记录仪与随身记录设备画面", "直播或录屏留存的关键片段"],
    requirements: ["尽量提交未经剪辑的原始文件", "注意删除视频中的定位与设备信息", "提前对画面中的人脸做模糊处理", "说明拍摄时间、地点与拍摄者身份"],
    tag: "文件较大",
  },
  {
    id: "audio",
    slug: "audio",
    icon: "ri-mic-line",
    name: "录音证据提交",
    short: "通话、会议与现场收音",
    summary:
      "支持通话录音、现场收音、会议录音等音频材料。请一并说明录音的场合与对话双方关系，便于编辑判断证据价值。",
    scenes: ["客服与销售通话录音", "内部会议与谈话录音", "现场环境音与突发事件收音", "带有明确时间点的语音证据"],
    requirements: ["保留原始音频，不要做降噪或变速", "说明录音是否取得对方知情同意", "补充对话背景与关键时间点", "提交时对可识别身份的音色做处理说明"],
    tag: "需说明背景",
  },
];

export const processSteps = [
  {
    id: "p1",
    step: "01",
    icon: "ri-route-line",
    title: "选择投稿通道",
    desc: "根据手里的素材类型，从图文、匿名私信、视频、录音四个入口中选择最合适的一个，不确定也可以先选图文说明情况。",
  },
  {
    id: "p2",
    step: "02",
    icon: "ri-upload-cloud-2-line",
    title: "提交线索与素材",
    desc: "填写必要信息并描述线索要点。较大的视频与音频文件，我们会通过安全链接引导你上传，避免公开传输。",
  },
  {
    id: "p3",
    step: "03",
    icon: "ri-file-shield-2-line",
    title: "脱敏与初步核实",
    desc: "编辑在收到线索后进行身份信息脱敏，并对关键时间、地点、人物关系做交叉核实，判断线索的可用方向。",
  },
  {
    id: "p4",
    step: "04",
    icon: "ri-notification-3-line",
    title: "跟进与反馈",
    desc: "若你留下了安全的联系方式，我们会同步处理进展；若选择完全匿名，我们也会说明线索是否被采纳及原因。",
  },
];

export const privacyPoints = [
  {
    id: "pv1",
    icon: "ri-user-forbid-line",
    title: "全程可匿名",
    desc: "手机号与邮箱都为选填项，不填写同样可以完成提交，系统不会以身份信息作为受理前提。",
  },
  {
    id: "pv2",
    icon: "ri-database-2-line",
    title: "信息最小化收集",
    desc: "只收集核实线索所必需的内容，不索取身份证件、住址等与线索无关的个人资料。",
  },
  {
    id: "pv3",
    icon: "ri-lock-2-line",
    title: "加密传输",
    desc: "所有提交内容通过加密通道传输，页面不保留你的输入草稿，关闭页面即清空。",
  },
  {
    id: "pv4",
    icon: "ri-aspect-ratio-line",
    title: "素材脱敏处理",
    desc: "刊发前会对画面人脸、声音音色、门牌与车牌等可识别标识做模糊或变声处理。",
  },
  {
    id: "pv5",
    icon: "ri-delete-bin-6-line",
    title: "可申请销毁",
    desc: "若你改变主意，可联系编辑申请删除已提交的素材与描述，我们会在核实后移除相关记录。",
  },
  {
    id: "pv6",
    icon: "ri-shield-check-line",
    title: "编辑全程守则",
    desc: "处理线索的编辑遵循统一的保密守则，不得向任何第三方透露投稿者身份与未刊发材料。",
  },
];

export const tipCategories = [
  { id: "c1", name: "民生维权", icon: "ri-home-heart-line", count: "2,140" },
  { id: "c2", name: "消费陷阱", icon: "ri-shopping-bag-3-line", count: "1,876" },
  { id: "c3", name: "食品安全", icon: "ri-restaurant-2-line", count: "1,205" },
  { id: "c4", name: "环境生态", icon: "ri-plant-line", count: "980" },
  { id: "c5", name: "交通出行", icon: "ri-roadster-line", count: "1,432" },
  { id: "c6", name: "教育培训", icon: "ri-book-open-line", count: "1,067" },
  { id: "c7", name: "医疗健康", icon: "ri-heart-pulse-line", count: "864" },
  { id: "c8", name: "职场用工", icon: "ri-briefcase-line", count: "1,318" },
  { id: "c9", name: "网络诈骗", icon: "ri-alarm-warning-line", count: "1,594" },
  { id: "c10", name: "房产物业", icon: "ri-building-2-line", count: "742" },
];

export const homeFaqs = [
  {
    id: "hf1",
    q: "完全匿名投稿后，还能知道线索有没有被采纳吗？",
    a: "可以。即使不留下任何联系方式，我们也会在投稿时生成的查询口令中记录处理状态，你用口令即可查看线索是否被采纳以及大致处理方向，全程不需要暴露身份。",
  },
  {
    id: "hf2",
    q: "视频素材很大，直接上传会不会泄露我的信息？",
    a: "不会。表单页只收集文字描述，视频与录音这类大文件会由编辑通过安全链接引导你上传，链接一次性有效，且我们建议你先删除文件中的定位与设备信息。",
  },
  {
    id: "hf3",
    q: "我提交的线索会被原样发布出来吗？",
    a: "不会原样发布。编辑会先做身份脱敏与事实核实，对画面人脸、声音音色、门牌车牌等可识别信息统一处理，并在刊发前确认不会因细节反推出投稿者身份。",
  },
  {
    id: "hf4",
    q: "线索需要多完整才值得提交？",
    a: "不要求完整。哪怕只有一段描述、一张截图，也值得先提交。你可以先说明已知的部分，编辑会判断后续还需要补充哪些材料，再与你约定补充方式。",
  },
  {
    id: "hf5",
    q: "如果提交后我后悔了，可以撤回来吗？",
    a: "可以。只要留下任意一种可联系到你的方式，或凭投稿口令联系我们，就能申请撤回；已经刊发的内容我们会评估后做下线或更正处理。",
  },
];

export const faqGroups = [
  {
    id: "g1",
    name: "投稿相关",
    icon: "ri-send-plane-line",
    items: [
      {
        id: "f101",
        q: "投稿需要注册账号或实名认证吗？",
        a: "不需要。四条投稿通道都不要求注册、不要求实名，也不需要填写身份证件信息。你只需描述线索要点并选择是否留下联系方式即可完成提交。",
      },
      {
        id: "f102",
        q: "一个人可以同时用多个通道投稿吗？",
        a: "可以，但建议同一件事只选一个主通道，避免重复处理。比如先用图文通道说明情况，后续补充视频时再通过原线索的口令追加，编辑就能把材料归到同一条线索下。",
      },
      {
        id: "f103",
        q: "投稿内容有字数限制吗？",
        a: "线索描述建议控制在 500 字以内。重点说清时间、地点、涉及方、事情经过和你想核实的问题即可，细节可以在编辑回访时继续补充，不必一次写全。",
      },
      {
        id: "f104",
        q: "用手机投稿方便吗？",
        a: "方便。投稿表单在手机、平板和电脑上都能正常填写与提交，页面也会自动适配屏幕宽度。手机端同样可以上传截图和照片。",
      },
      {
        id: "f105",
        q: "投稿后会立刻有人联系我吗？",
        a: "如果你留下了安全的联系方式，编辑通常会在工作日内 6 小时左右做首次响应；若选择完全匿名，则不会主动联系，你可用投稿口令自行查询处理状态。",
      },
    ],
  },
  {
    id: "g2",
    name: "隐私与安全",
    icon: "ri-shield-user-line",
    items: [
      {
        id: "f201",
        q: "平台会记录我的真实 IP 或设备信息吗？",
        a: "我们不会把 IP 或设备信息用于识别投稿者身份，也不会以此判断是否受理线索。为保障服务稳定，系统会保留必要的运行日志，但这些日志不对外提供，也不与投稿内容关联展示。",
      },
      {
        id: "f202",
        q: "什么样的联系方式算“安全的联系方式”？",
        a: "临时邮箱、新注册的社交账号、一次性号码，或你日常使用但未绑定真实姓名的账号都可以。避免使用与真实身份强关联的工作邮箱或实名手机号。",
      },
      {
        id: "f203",
        q: "编辑会不会把我的身份透露给被举报的一方？",
        a: "不会。编辑遵循统一的保密守则，不得向任何第三方透露投稿者身份信息与未经刊发的材料。刊发内容也会经过脱敏，避免因细节反推出投稿者。",
      },
      {
        id: "f204",
        q: "如果被举报方通过法律途径要求提供投稿者信息怎么办？",
        a: "我们会依法审慎处理每一个此类请求，并在提交稿件时尽量做到去身份化，从源头上降低风险。若确实面临强制要求，我们会在法律允许的范围内第一时间告知你。",
      },
    ],
  },
  {
    id: "g3",
    name: "素材要求",
    icon: "ri-folder-shield-2-line",
    items: [
      {
        id: "f301",
        q: "可以提交二手转发的素材吗？",
        a: "可以提交，但请务必说明来源以及你是否能确认其真实性。二手素材我们只会作为参考方向，通常还需要找到一手来源或其他佐证才会进入核实流程。",
      },
      {
        id: "f302",
        q: "视频和录音需要先剪辑或降噪吗？",
        a: "不需要，反而建议保留原始文件。剪辑、降噪、变速都会削弱材料的证据价值。若原始文件中包含你的个人信息，请单独说明，我们会做针对性处理而不是整体修改。",
      },
      {
        id: "f303",
        q: "照片和截图有格式要求吗？",
        a: "常见的 JPG、PNG、HEIC 都可以，截图请尽量保留完整的界面信息与时间标识。若画质较低，可同时用文字补充画面内容，便于编辑判断。",
      },
      {
        id: "f304",
        q: "手里素材很多，一次全部提交好吗？",
        a: "不建议。一次性提交大量材料容易让重点被淹没，也会增加泄露风险。建议先提交最核心的两三项，说明整体情况，等编辑确认方向后再分批补充。",
      },
    ],
  },
  {
    id: "g4",
    name: "后续处理",
    icon: "ri-flow-chart",
    items: [
      {
        id: "f401",
        q: "线索提交后一般会经过哪些环节？",
        a: "依次为登记归类、身份脱敏、初步核实、补充取证、内容撰写与刊发评估。不是每条线索都会走到刊发环节，无法刊发时我们会说明主要原因。",
      },
      {
        id: "f402",
        q: "为什么我的线索没有被跟进？",
        a: "常见原因包括关键事实无法交叉核实、材料来源无法确认、涉及事项已有公开结论，或线索超出我们当前的处理范围。你可以追问，我们会尽量给出具体原因。",
      },
      {
        id: "f403",
        q: "线索被采纳后会通知我吗？",
        a: "若你留下了安全联系方式，会在刊发前后同步进展。若选择完全匿名，则可通过投稿口令查询状态，我们不会主动联系，以免对你造成不必要的打扰。",
      },
      {
        id: "f404",
        q: "刊发内容出现偏差怎么办？",
        a: "你可以凭投稿口令或联系方式提出更正。核实后我们会尽快更新内容，必要时发布更正说明。我们希望最终刊出的内容经得起你和其他读者的检验。",
      },
    ],
  },
];

export const guideTips = [
  {
    id: "gt1",
    icon: "ri-fingerprint-line",
    title: "先保护自己，再谈线索",
    desc: "在提交任何材料之前，先判断一旦身份暴露可能带来的后果。如果风险较高，宁可从匿名私信通道开始，先沟通安全边界。",
  },
  {
    id: "gt2",
    icon: "ri-device-line",
    title: "用独立设备或干净账号",
    desc: "尽量使用与日常工作、生活账号无关的设备或新注册账号提交，避免社交平台的实名绑定成为识别身份的入口。",
  },
  {
    id: "gt3",
    icon: "ri-file-3-line",
    title: "保留原始文件",
    desc: "视频、音频、照片都保留原始版本，不要剪辑、压缩或加滤镜。原始文件的时间戳与元数据本身就是重要的求证依据。",
  },
  {
    id: "gt4",
    icon: "ri-map-pin-time-line",
    title: "补齐时间、地点与人物关系",
    desc: "同一件事在不同人眼中差异很大。把时间点、地点、涉及方及其关系说清楚，编辑才更容易判断线索是否成立。",
  },
  {
    id: "gt5",
    icon: "ri-blur-off-line",
    title: "上传前先做打码处理",
    desc: "截图中的姓名、电话、头像、门牌，视频中的人脸，都建议先做模糊处理。不确定如何处理时，可以先描述、后补交。",
  },
  {
    id: "gt6",
    icon: "ri-signal-wifi-off-line",
    title: "避免在公共网络下提交敏感材料",
    desc: "公共 Wi-Fi 环境存在被监听的可能。涉及敏感内容时，优先使用自己的移动网络，并确认页面地址为加密连接。",
  },
  {
    id: "gt7",
    icon: "ri-time-line",
    title: "留一种安全的联系方式",
    desc: "完全匿名是最安全的选择，但留一种不与真实身份绑定的联系方式，能显著提高线索被核实和采纳的概率。",
  },
  {
    id: "gt8",
    icon: "ri-stack-line",
    title: "分批提交，别一次梭哈",
    desc: "先交最核心的两三项材料，确认对接顺畅、对方可信后，再决定是否补充其余内容，给自己留出退路。",
  },
];

export const materialChecklist = [
  { id: "mc1", label: "原始视频或音频文件", hint: "未经剪辑、压缩的版本" },
  { id: "mc2", label: "拍摄或录制时间", hint: "精确到日期，重要事件精确到时段" },
  { id: "mc3", label: "发生地点", hint: "城市与具体场所，不确定可描述范围" },
  { id: "mc4", label: "涉及方名称", hint: "机构、门店或相关人员称谓" },
  { id: "mc5", label: "事件经过简述", hint: "起因、经过、结果三句话讲清楚" },
  { id: "mc6", label: "其他佐证材料", hint: "合同、票据、聊天记录等" },
];

export const dosList = [
  "提交前先确认素材中没有暴露自己的位置与身份",
  "用文字补充说明画面或音频里不容易看懂的部分",
  "记录下投稿口令，用于后续查询处理状态",
  "如实说明材料来源，是自己拍摄还是他人提供",
  "对不确定的信息明确标注“尚未核实”",
];

export const dontsList = [
  "不要在公共社交平台公开讨论自己提交了哪些线索",
  "不要对原始视频、音频做剪辑、变速或降噪处理",
  "不要一次提交与线索无关的大量个人资料",
  "不要使用与真实身份强绑定的工作邮箱投稿",
  "不要把全部证据一次性交给任何个人账号",
];

export const aboutValues = [
  {
    id: "av1",
    icon: "ri-equalizer-line",
    title: "真实优先",
    desc: "我们宁可慢一点，也不刊发未经交叉核实的材料。每条线索都要经过来源确认与事实比对，才进入撰写环节。",
  },
  {
    id: "av2",
    icon: "ri-shield-line",
    title: "保护投稿者",
    desc: "投稿者的安全感，是平台存在的理由。我们在流程设计上默认匿名、默认脱敏、默认最小化收集信息。",
  },
  {
    id: "av3",
    icon: "ri-scales-3-line",
    title: "克制表达",
    desc: "不用煽动性标题放大情绪，不预设立场。把事实讲清楚，把证据摆出来，让读者自己判断。",
  },
  {
    id: "av4",
    icon: "ri-refresh-line",
    title: "可更正",
    desc: "刊发内容出现偏差时，我们接受更正并公开说明。可被纠错，是内容可信度的一部分。",
  },
];

export const testimonials = [
  {
    id: "tm1",
    quote:
      "一开始很担心被认出来，所以先用了匿名私信通道。编辑没有追问我是谁，只是反复确认时间线，后来关键画面也做了处理，整个过程比我想象中安全。",
    author: "林先生",
    role: "前企业员工 · 职场用工线索",
  },
  {
    id: "tm2",
    quote:
      "手里的监控视频有四十多分钟，我以为没地方交。提交文字说明后当天就收到了安全上传链接，链接用完即失效，这点让我比较放心。",
    author: "周女士",
    role: "小区住户 · 物业纠纷线索",
  },
  {
    id: "tm3",
    quote:
      "最有用的是那份安全投稿指南。按上面的清单把时间、地点、涉及方理清楚之后，编辑回访时问的问题少了很多，效率高很多。",
    author: "陈先生",
    role: "个体经营者 · 消费陷阱线索",
  },
  {
    id: "tm4",
    quote:
      "我的线索最后没有被刊发，但对方说明了原因，还告诉我还需要补充哪类材料。这种把话说清楚的态度，让我愿意继续关注这里。",
    author: "匿名投稿者",
    role: "环保线索 · 未刊发",
  },
];

export const seoKeywords = "爆料投稿,匿名私信投稿,视频素材上传,图文投稿通道,录音证据提交";